import type { ReactNode } from 'react'

export type ModalBlockAlign = 'left' | 'center'
export type ModalCtaStyle = 'primary' | 'secondary' | 'inline_link'

/** The gap ABOVE a top-level block. Ignored inside a row, where columns sit side by side. */
export type ModalBlockSpacing = 'default' | 'small' | 'none'
export type ModalHeadingSize = 'default' | 'large'
/** Named looks rather than free size and colour, so a paragraph can only be one of the designed steps. */
export type ModalParagraphStyle = 'body' | 'emphasis' | 'lead'
export type ModalCardStyle = 'default' | 'accent'

export type ModalRowLayout = {
  layout?: 'equal' | 'compact'
  gap?: 'small' | 'medium' | 'large'
  vertical_align?: 'top' | 'center' | 'bottom'
  horizontal_align?: 'left' | 'center' | 'right'
  mobile_layout?: 'stack' | 'inline'
  mobile_align?: 'inherit' | 'center'
}

export const MODAL_ROW_DEFAULTS = {
  layout: 'equal',
  gap: 'large',
  vertical_align: 'top',
  horizontal_align: 'center',
  mobile_layout: 'stack',
  mobile_align: 'inherit',
} as const satisfies Required<ModalRowLayout>

/**
 * How much of its container an image or a video fills. The container is the
 * block's own column inside a row, and the card body outside one, so the same
 * step reads narrower in a two-column row than it does on its own line.
 */
export type ModalMediaWidth = 'full' | 'large' | 'medium' | 'small'

/** Where the asset sits once it is narrower than its container. */
export type ModalMediaAlign = 'left' | 'center' | 'right'

export type ModalBlockPayload = ModalRowLayout & {
  type: string
  align?: ModalBlockAlign | ModalMediaAlign
  children?: readonly ModalBlockPayload[]
  heading?: ReactNode
  highlight?: string
  items?: readonly ReactNode[]
  link?: string
  size?: ModalHeadingSize
  spacing?: ModalBlockSpacing
  /** One wire field, three value sets: the CTA's, the paragraph's and the card's. */
  style?: ModalCtaStyle | ModalParagraphStyle | ModalCardStyle
  text?: ReactNode
  url?: string
  width?: ModalMediaWidth
}
